module.exports = __webpack_public_path__ + "static/media/ASAB_40_3.d81b503a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/ASAB_40_3.jpg
// module id = 1300
// module chunks = 1